export const DIGITAL_SKILL_LEVEL = [
    {
        code: "LOW",
    },
    {
        code: "MEDIUM",
    },
    {
        code: "HIGH",
    },
];